//TODO : move those helper functions to the sdk.

import { IReviewControlOptions, ReviewControlColumns } from '../Interfaces';
import { sdkInstance } from '../Instance';
import {
  IApp,
  IDropdownParams,
  IStringMap,
  IStringStringArrayMap,
} from 'matrix-requirements-sdk/client';

const ml = sdkInstance.ml;
const globalMatrix = sdkInstance.globalMatrix;

export class ReviewHelper {
  static reviewOptionsSetting = 'dd_reviewOptions';

  static defaultOptions: IReviewControlOptions = {
    controlState: sdkInstance['ControlState'].FormView, // read only rendering
    canEdit: false, // whether data can be edited
    fieldValue: '', //
    parameter: {
      readonly: false, // can be set to overwrite the default readonly status
    },
  };

  static analyzeReview(
    fieldId: number,
    tableData: IStringMap[],
    passedItems: string[],
    failedItems: string[],
    todoItems: string[],
  ) {
    let reviewers = ReviewHelper.getReviewers(tableData);

    // get the cell values which represent the different states
    let passed = ReviewHelper.getReviewOptions(fieldId, true, false, false);
    let failed = ReviewHelper.getReviewOptions(fieldId, false, true, false);
    let todo = ReviewHelper.getReviewOptions(fieldId, false, false, true);

    // for each row - check items in which bucket they need to go
    for (let row of tableData) {
      let stillTodo = false;
      let alreadyFailed = false;
      $.each(reviewers, function (cidx, column) {
        if (!row[column] || todo.indexOf(row[column]) != -1) {
          stillTodo = true;
        } else if (failed.indexOf(row[column]) != -1) {
          alreadyFailed = true;
        } else if (passed.indexOf(row[column]) != -1) {
        } else {
          // default unknown state
          stillTodo = true;
        }
      });
      if (alreadyFailed) {
        failedItems.push(ReviewHelper.getItem(row));
      } else if (stillTodo) {
        todoItems.push(ReviewHelper.getItem(row));
      } else {
        passedItems.push(ReviewHelper.getItem(row));
      }
    }
  }

  // get all columns which are user or ACL columns
  static getReviewers(tableData: IStringMap[]): string[] {
    if (tableData.length == 0) return [];

    let reviewColumns = Object.keys(tableData[0]).filter(function (c) {
      return (
        c[0] != '_' &&
        c != ReviewControlColumns.COL_ITEM &&
        c != ReviewControlColumns.COL_COMMENT_LOG
      );
    });
    return reviewColumns.sort();
  }

  static getItem(row: IStringMap): string {
    return ReviewHelper.getItemFromCell(row['reviewitem']);
  }

  static getItemFromCell(value: string): string {
    return value.split(' ')[0].replace('!', '');
  }

  // returns all drop down options for the wanted principal states
  static getReviewOptions(
    fieldId: number,
    passed: boolean,
    failed: boolean,
    todo: boolean,
  ): string[] {
    let dd: IDropdownParams = ReviewHelper.getDropdownParams(fieldId);

    if (!dd || !dd.options) {
      ml.Logger.log('warn', 'no setting for dropdowns in review table');
      return [];
    }
    return dd.options
      .filter(function (ddo) {
        return (
          (todo && (!ddo.class || ddo.class == 'todo')) ||
          (passed && ddo.class == 'passed') ||
          (failed && ddo.class == 'failed')
        );
      })
      .map(function (ddo) {
        return ddo.id;
      });
  }

  private static getDropdownParams(fieldId: number): IDropdownParams {
    let field = globalMatrix.ItemConfig.getFieldsOfType('reviewControl').filter(
      function (rcs) {
        return rcs.field.id == fieldId;
      },
    );
    if (
      field.length &&
      field[0].field.parameterJson &&
      field[0].field.parameterJson.statusDropdown
    ) {
      return <IDropdownParams>(
        globalMatrix.ItemConfig.getSettingJSON(
          field[0].field.parameterJson.statusDropdown,
        )
      );
    }
    return <IDropdownParams>(
      globalMatrix.ItemConfig.getSettingJSON(ReviewHelper.reviewOptionsSetting)
    );
  }
  static getItemsToDoByUser(
    fieldId: number,
    tableData: IStringMap[],
  ): IStringStringArrayMap {
    let that = this;

    let todos: IStringStringArrayMap = {};

    // get dropdown setting options which are considered to be still todo
    let todoStates = ReviewHelper.getReviewOptions(fieldId, false, false, true);

    let columns = ReviewHelper.getReviewers(tableData);

    $.each(columns, function (idx, column) {
      if (!todos[column]) {
        // might be first task of user
        todos[column] = [];
      }
      // get items which still need to be reviewed
      $.each(tableData, function (rowIdx, row) {
        if (!row[column] || todoStates.indexOf(row[column]) != -1) {
          // in table we keep the ID with a ! to render title
          let item = ReviewHelper.getItem(row);
          todos[column].push(item);
        }
      });
    });

    return todos;
  }
}
